"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var fabric_1 = require("@aperza/fabric");
var CreateStamp_1 = require("./CreateStamp");
var AcPdf_1 = require("../../pdf/AcPdf");
var AcButton_1 = __importDefault(require("../../button/AcButton"));
var AcStampButtonSetting_1 = require("./AcStampButtonSetting");
var AcStampButtonDropdown_1 = require("./AcStampButtonDropdown");
var AcStampButton_module_scss_1 = __importDefault(require("./AcStampButton.module.scss"));
var AcSetPhraseRecentlyUsedButtons_1 = require("./AcSetPhraseRecentlyUsedButtons");
/**
 * Fit the SVG to the button size
 */
var getScale = function (buttonWidth, buttonHeight, fabricObject) {
    var actualObjectWidth = fabricObject.aCoords.tr.x - fabricObject.aCoords.tl.x;
    var actualObjectHeight = fabricObject.aCoords.br.y - fabricObject.aCoords.tr.y;
    var scale = Math.min(buttonWidth / actualObjectWidth, buttonHeight / actualObjectHeight);
    return scale;
};
exports.AcStampButton = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 100 : _b, _c = _a.height, height = _c === void 0 ? 100 : _c, stamp = _a.stamp, _d = _a.size, size = _d === void 0 ? 'stamp_md' : _d, // default size is MD
    settingButton = _a.settingButton, onClickSetting = _a.onClickSetting, setActiveMenu = _a.setActiveMenu, label = _a.label, dropdownProps = _a.dropdownProps, dropdownData = _a.dropdownData, preview = _a.preview;
    var canvasMethodsRef = react_1.useContext(AcPdf_1.CanvasContext);
    var stampCanvasRef = react_1.useRef(null);
    /**
     * The original fabricObject from the Stamp object.
     * Not scaled and rotated.
     */
    var _e = react_1.useState({}), fabricObject = _e[0], setFabricObject = _e[1];
    var _f = react_1.useState(), canvas = _f[0], setCanvas = _f[1];
    var drawStamp = function () {
        if (canvas) {
            (function () { return __awaiter(void 0, void 0, void 0, function () {
                var _fabricObject, _fabricObjectForButton, scale;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, CreateStamp_1.renderStamp(stamp)];
                        case 1:
                            _fabricObject = _a.sent();
                            setFabricObject(_fabricObject);
                            return [4 /*yield*/, CreateStamp_1.renderStamp(stamp, {}, true)];
                        case 2:
                            _fabricObjectForButton = _a.sent();
                            canvas.clear();
                            canvas.add(_fabricObjectForButton); //this needs to be before getScale() is called because getScale() needs the bounding box dimensions
                            scale = getScale(width, height, _fabricObjectForButton);
                            if (stamp.type === 'setPhrase' || stamp.type === 'textbox') {
                                _fabricObjectForButton.fill = '#0c4e93'; // set color to blue for set phrase stamp button
                            }
                            _fabricObjectForButton.scale(scale);
                            _fabricObjectForButton.set({
                                left: width / 2,
                                top: height / 2,
                                originX: 'center',
                                originY: 'center',
                            });
                            return [2 /*return*/];
                    }
                });
            }); })();
        }
    };
    react_1.useEffect(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var newCanvas;
            return __generator(this, function (_a) {
                newCanvas = new fabric_1.fabric.StaticCanvas(stampCanvasRef.current, {
                    width: width,
                    height: height,
                    selection: false,
                });
                setCanvas(newCanvas);
                return [2 /*return*/];
            });
        }); })();
    }, []);
    react_1.useEffect(function () {
        drawStamp();
    }, [canvas, JSON.stringify(stamp)]);
    var onClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var cloned;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!fabricObject.clone) return [3 /*break*/, 2];
                    return [4 /*yield*/, CreateStamp_1.cloneFabricObject(fabricObject)];
                case 1:
                    cloned = _a.sent();
                    canvasMethodsRef.current.addStamp(cloned, undefined, undefined, undefined, undefined, stamp);
                    AcSetPhraseRecentlyUsedButtons_1.setFaxSetPhraseIds(stamp);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var renderStampSize = function () {
        var sizeValue = 0;
        switch (size) {
            case 'stamp_sm':
                sizeValue = 70;
                break;
            case 'stamp_md':
                sizeValue = 150;
                break;
            case 'stamp_lg':
                sizeValue = 300;
                break;
            default:
                break;
        }
        return sizeValue;
    };
    var renderPaddingSize = function () {
        var stampPaddingClass = '';
        switch (size) {
            case 'stamp_sm':
                stampPaddingClass = 'p-2';
                break;
            case 'stamp_md':
                stampPaddingClass = 'p-6';
                break;
            case 'stamp_lg':
                stampPaddingClass = 'p-4';
                break;
            default:
                break;
        }
        return stampPaddingClass;
    };
    return (react_1.default.createElement("div", { className: "px-1 mb-4" },
        react_1.default.createElement("div", { className: "position-relative " + AcStampButton_module_scss_1.default.stampBtn },
            preview && react_1.default.createElement("canvas", { ref: stampCanvasRef }),
            !preview && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(AcButton_1.default, { variant: "apzlightblue", className: "rounded border-right border-bottom d-block position-relative " + renderPaddingSize() + " " + (label ? 'mb-1' : ''), width: renderStampSize(), height: renderStampSize(), onClick: onClick },
                    react_1.default.createElement("canvas", { ref: stampCanvasRef })),
                onClickSetting && (react_1.default.createElement(AcStampButtonSetting_1.AcStampButtonSetting, { settingButton: settingButton, onClickSetting: onClickSetting })),
                dropdownProps && (react_1.default.createElement(AcStampButtonDropdown_1.AcStampButtonDropdown, { dropdownProps: dropdownProps, dropdownData: dropdownData })))),
            label && react_1.default.createElement("span", { className: "fs-13 font-weight-light" }, label))));
};
exports.AcStampButton.displayName = 'AcStampButton';
//# sourceMappingURL=AcStampButton.js.map